import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";

import "./App.css";

import Navbar from "./Layout/Navbar";
import Footer from "./Layout/Footer";
import Home from "./Home";
import ProtectedCourse from "./ProtectedCourse";
import CourseDetails from "./CourseDetails";
import FreeDemo from "./FreeDemo";
import Gallery from "./Gallery";

import AdminLogin from "./MyAdmin/AdminLogin";
import RequireAdmin from "./MyAdmin/RequireAdmin";
import AdminLayout from "./MyAdmin/AdminLayout";

import CourseManager from "./MyAdmin/CourseManager";
import YouTubeManager from "./MyAdmin/YouTubeManager";
import DesignerManager from "./MyAdmin/DesignerManager";
import CategoryManager from "./MyAdmin/CategoryManager";
import MediaManager from "./MyAdmin/MediaManager";
import RegisteredUsers from "./MyAdmin/RegisteredUsers";
import AdminProfile from "./MyAdmin/AdminProfile";
import AdminChangePassword from "./MyAdmin/AdminChangePassword";
import Profile from "./Profile";
import ChangePassword from "./ChangePassword";
import EmbroideryVideoManager from "./MyAdmin/EmbroideryVideoManager";

function PublicLayout() {
  return (
    <>
      <Navbar />

      <div className="app-content">
        <Outlet />
      </div>

      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route
            path="/courses/:courseId"
            element={
              <ProtectedCourse>
                <CourseDetails />
              </ProtectedCourse>
            }
          />

          <Route
            path="/free-demo"
            element={
              <ProtectedCourse>
                <FreeDemo />
              </ProtectedCourse>
            }
          />
        </Route>

        <Route path="/MyAdmin/login" element={<AdminLogin />} />

        <Route element={<RequireAdmin />}>
          <Route path="/MyAdmin" element={<AdminLayout />}>
            <Route index element={<Navigate to="courses" replace />} />

            <Route path="courses" element={<CourseManager />} />
            <Route path="youtube" element={<YouTubeManager />} />
            <Route path="designers" element={<DesignerManager />} />
            <Route path="categories" element={<CategoryManager />} />
            <Route path="media" element={<MediaManager />} />
            <Route path="users" element={<RegisteredUsers />} />
            <Route path="profile" element={<AdminProfile />} />
            <Route path="change-password" element={<AdminChangePassword />} />
            <Route
              path="embroidery-videos"
              element={<EmbroideryVideoManager />}
            />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
